import { startCase, capitalize } from 'lodash';

const convertEnumString = (enumm) => startCase(capitalize(enumm));

export { convertEnumString };
